import React from 'react';

/**
 * 捐赠成功图标（主题色：圆形背景 + 对勾）
 */
export const DonationSuccessIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 265 265"
    fill="none"
    {...props}
  >
    {/* 主圆环/圆形背景 - 使用主题色 */}
    <circle cx="132.5" cy="120" r="56" fill="currentColor" fillOpacity="0.12" />
    <circle cx="132.5" cy="120" r="46" fill="currentColor" fillOpacity="0.22" />
    <circle cx="132.5" cy="120" r="36" fill="currentColor" fillOpacity="0.35" />
    {/* 中心对勾 */}
    <path
      d="M115 120 L124 129 L152 101"
      stroke="currentColor"
      strokeWidth="10"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
      opacity="0.95"
    />
    {/* 底部装饰小星星 - 主题色 */}
    <path
      d="M199.69 224L201.7 229.64L207.35 231.66L201.7 233.68L199.69 239.32L197.64 233.68L192 231.66L197.64 229.64L199.69 224Z"
      fill="currentColor"
      fillOpacity="0.55"
    />
    <path
      d="M63.93 199L65.5 203.35L69.85 204.9L65.5 206.45L63.93 210.8L62.35 206.45L58 204.9L62.35 203.35L63.93 199Z"
      fill="currentColor"
      fillOpacity="0.55"
    />
  </svg>
);
